import { memo } from "react"

interface IconAddLargeProps {
  disabled?: boolean
}

const IconAddLarge = (props: IconAddLargeProps) => {
  const { disabled = false } = props

  return (
    <>
      {!disabled && (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.2527 0.666504H14.746C21.6974 0.666504 27.3327 6.30175 27.3327 13.2532V14.7465C27.3327 21.6979 21.6974 27.3332 14.746 27.3332H13.2527C6.30126 27.3332 0.666016 21.6979 0.666016 14.7465V13.2532C0.666016 6.30175 6.30126 0.666504 13.2527 0.666504ZM14.9993 14.9998H19.3327C19.885 14.9998 20.3327 14.5521 20.3327 13.9998C20.3327 13.4476 19.885 12.9998 19.3327 12.9998H14.9993V8.6665C14.9993 8.11422 14.5516 7.6665 13.9993 7.6665C13.4471 7.6665 12.9993 8.11422 12.9993 8.6665V12.9998H8.66602C8.11373 12.9998 7.66602 13.4476 7.66602 13.9998C7.66602 14.5521 8.11373 14.9998 8.66602 14.9998H12.9993V19.3332C12.9993 19.8855 13.4471 20.3332 13.9993 20.3332C14.5516 20.3332 14.9993 19.8855 14.9993 19.3332V14.9998Z"
            fill="#29369F"
          />
        </svg>
      )}

      {disabled && (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.2527 0.666504H14.746C21.6974 0.666504 27.3327 6.30175 27.3327 13.2532V14.7465C27.3327 21.6979 21.6974 27.3332 14.746 27.3332H13.2527C6.30126 27.3332 0.666016 21.6979 0.666016 14.7465V13.2532C0.666016 6.30175 6.30126 0.666504 13.2527 0.666504ZM14.9993 14.9998H19.3327C19.885 14.9998 20.3327 14.5521 20.3327 13.9998C20.3327 13.4476 19.885 12.9998 19.3327 12.9998H14.9993V8.6665C14.9993 8.11422 14.5516 7.6665 13.9993 7.6665C13.4471 7.6665 12.9993 8.11422 12.9993 8.6665V12.9998H8.66602C8.11373 12.9998 7.66602 13.4476 7.66602 13.9998C7.66602 14.5521 8.11373 14.9998 8.66602 14.9998H12.9993V19.3332C12.9993 19.8855 13.4471 20.3332 13.9993 20.3332C14.5516 20.3332 14.9993 19.8855 14.9993 19.3332V14.9998Z"
            fill="#d1d1d1"
          />
        </svg>
      )}
    </>
  )
}

export default memo(IconAddLarge)
